module.exports = __webpack_public_path__ + "img/open-site-info-menu.e74065f0.png";